/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NameAndEmailFromNrpsOnlySettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NAME_AND_EMAIL_FROM_NRPS_ONLY')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class NameAndEmailFromNrpsOnlySetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NameAndEmailFromNrpsOnlySettingParser.decode(input).map(res => new NameAndEmailFromNrpsOnlySetting(res));
    }
    static unsafeDecode(input) {
        return NameAndEmailFromNrpsOnlySetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NameAndEmailFromNrpsOnlySettingParser.encode(data);
    }
    static schema() {
        return NameAndEmailFromNrpsOnlySettingParser.schema();
    }
}
